module.exports = __webpack_public_path__ + "static/janika-c689b35add8ac99aa5cc9c449d9c9394.jpeg";